import WelcomePost from '../content/posts/welcome-to-bhu-tourism-club.mdx';

export const categories = [
    {
        id: 1,
        name: "Tourism Ecosystem",
        slug: "tourism-ecosystem",
        description: "Insights into the tourism environment, heritage, and leadership opportunities at BHU."
    },
    {
        id: 2,
        name: "Leadership & Skills",
        slug: "leadership-skills",
        description: "Essential skills, mindset, and strategies for building a career in tourism."
    },
    {
        id: 3,
        name: "Heritage & Innovation",
        slug: "heritage-innovation",
        description: "Exploring cultural legacy through the lens of modern technology and innovation."
    },
    {
        id: 4,
        name: "Announcements",
        slug: "announcements",
        description: "Official updates and news from the BHU Tourism Club."
    }
];

export const posts = [
    {
        id: 1,
        title: "Welcome to BHU Tourism Club",
        slug: "welcome-to-bhu-tourism-club",
        excerpt: "We are excited to launch our official platform for heritage, tourism, and innovation at Banaras Hindu University.",
        content_component: WelcomePost,
        featured_image: "/assets/images/bhu-hero.png",
        category_id: 4,
        category_name: "Announcements",
        author_name: "BHU Tourism Club Team",
        created_at: "2026-05-15T12:00:00Z",
        status: "published",
        is_featured: true,
        tags: ["announcement", "welcome", "BHU"]
    }
];
